<ng-container xmlns="http://www.w3.org/1999/html">
  <!--</editor-fold>-->
  <div class="row">
    <ng-container *ngIf="(employee$ | async) as employee; else loadingPersonalDataTemplate">
      <ng-container *ngIf="profileLoaded; else loadingPersonalDataTemplate">
        <ng-container *ngIf="(pinnedActivities$ | async) as activities">
          <div *ngFor="let activity of activities; let i = index" [ngClass]="{'col-12': activities.length === 1, 'col-md-6': activities.length > 1}" class="">
            <div class="card shadow">
              <div class="position-absolute" style="top: 0; right: 0; transform: translate(25%, -40%) rotate(30deg); z-index: 1">
                <i class="mdi mdi-pin mdi-36px"></i>
              </div>
              <app-help name="employee.detail.pinned_activity"></app-help>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <h4 class="mb-0">{{ activity.name }}</h4>
                    <small> {{activity.author_name}} | {{activity.created_at | date: 'dd.MM.yyyy HH:mm'}}</small>
                    <p class="pinned-activity-text mb-0 mt-1">
                      {{ expandedActivities[i] || !activity.description_perex ? activity.description : activity.description_perex }}
                    </p>
                    <div *ngIf="activity.description_perex" class="text-center mt-1">
                      <u (click)="expandedActivities[i] = true" *ngIf="!expandedActivities[i]">{{'global.action_show_more' | translate}}</u>
                      <u (click)="expandedActivities[i] = false" *ngIf="expandedActivities[i]">{{'global.action_show_less' | translate}}</u>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="col-12 col-lg-6 mb-2 mb-md-3">
          <app-employee-personal-data (refetchActiveRequests)="getActiveRequests(employee.employee_ID)" (refetchRequiredUpdates)="getRequiredDataUpdates(employee.employee_ID)"
                                      *ngIf="checkPermission('employeePersonalData') && (availableWidgets$ | async)?.employee?.overview?.personal_data"
                                      [employee]="employee"
                                      [entityRequests]="entityRequests"
                                      [requiredUpdates]="requiredUpdates"
                                      id="personal_info">
          </app-employee-personal-data>
        </div>

        <div *ngIf="checkPermission('employee', 'edit') && (availableWidgets$ | async)?.employee?.overview?.note" class="col-12 col-lg-6 mb-2 mb-md-3">
          <app-note
              [entity]="{ id: employee?.employee_ID, type: 'Employee' }"
          ></app-note>
        </div>

        <app-employee-contact-info
            (getEmployeeActiveRequests)="getActiveRequests(employee.employee_ID)"
            (getEmployeeRequiredUpdates)="getRequiredDataUpdates(employee.employee_ID)"
            [canShow]="{address: checkPermission('employeeAddress'), contactPerson: checkPermission('employeeContactPerson')}"
            [employee]="employee"
            [entityRequests]="entityRequests"
            [requiredUpdates]="requiredUpdates"
            class="{{this.canShowBoth((availableWidgets$ | async)?.employee?.overview) === true ? 'd-lg-flex w-100': (this.canShowSome((availableWidgets$ | async)?.employee?.overview) === true ? 'w-100 w-lg-50' : '')}}">
        </app-employee-contact-info>

        <div *ngIf="checkPermission('skill') && (availableWidgets$ | async)?.employee?.overview?.skills" class="col-12 col-lg-6 mb-2 mb-md-3">
          <div class="card shadow h-100">
            <app-help name="employee.detail.skills"></app-help>
            <div class="card-header card-header--padding">
              <div class="row">
                <div class="col-6 col-sm-6 col-md-7">
                  <p class="modal-title font-16 text-dark pt-2 pb-2">
                    <span>{{ 'employees.skills' | translate }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="control-label mb-1">{{ 'employees.hard_skills' | translate }}</div>
                  <app-tag-list
                      [category]="'hard_skill'"
                      [entityID]="employee.employee_ID"
                      [entityType]="'Employee'"
                      [modalTitle]="'employees.hard_skills' | translate"
                  >
                  </app-tag-list>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div class="control-label mb-1">{{ 'employees.soft_skills' | translate }}</div>
                  <app-tag-list
                      [category]="'soft_skill'"
                      [entityID]="employee.employee_ID"
                      [entityType]="'Employee'"
                      [modalTitle]="'employees.soft_skills' | translate"
                  >
                  </app-tag-list>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="checkPermission('employeeAccess') && (availableWidgets$ | async)?.employee?.overview?.accesses" class="col-12 col-lg-6 mb-2 mb-md-3">
          <app-employee-access></app-employee-access>
        </div>
        <div *ngIf="checkPermission('scheduledTask') && (availableWidgets$ | async)?.employee?.overview?.notifications" class="col-12 col-lg-6 mb-2 mb-md-3">
          <app-scheduled-task-list
              *ngIf="employee?.employee_ID"
              [entity]="{ id: employee?.employee_ID, type: 'Employee' }"
              [mode]="'compact'"
          ></app-scheduled-task-list>
        </div>

        <div *ngIf="checkPermission('employee', 'edit') && (availableWidgets$ | async)?.employee?.overview?.requests" class="col-12 col-lg-6">
          <app-entity-update-request
              *ngIf="employee?.employee_ID"
              [employeeIds]="[employee?.employee_ID]"
              [entityRequests]="entityRequests"
              [isEmployee]="true"
              [mode]="'noHeader'"
          ></app-entity-update-request>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #loadingPersonalDataTemplate>
      <div class="col-12">
        <div class="card shadow p-3">
          <div class="item">
            <ngx-skeleton-loader [theme]="{
        'margin': '15px 0'
      }" appearance="line" count="5"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card shadow p-3">
          <div class="item">
            <ngx-skeleton-loader [theme]="{
        'margin': '15px 0'
      }" appearance="line" count="5"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card shadow p-3">
          <div class="item">
            <ngx-skeleton-loader [theme]="{
        'margin': '15px 0'
      }" appearance="line" count="5"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
